import { css } from '@mui/material';

const CommonTypographyStyle = css`
  text-align: center;
  letter-spacing: -0.01em;
  font-style: normal;
`;

//HeadLine H1
export const H1 = css`
  ${CommonTypographyStyle}
  font-size: 72px;
  line-height: 90px;
`;

export const H1_REGULAR = css`
  ${H1}
  font-weight: 400;
`;

export const H1_MEDIUM = css`
  ${H1}
  font-weight: 500;
`;

export const H1_SEMIBOLD = css`
  ${H1}
  font-weight: 600;
`;

export const H1_BOLD = css`
  ${H1}
  font-weight: 700;
`;

//HeadLine H2

export const H2 = css`
  ${CommonTypographyStyle}
  font-size: 30px;
  line-height: 38px;
`;

export const H2_REGULAR = css`
  ${H2}
  font-weight: 400;
`;

export const H2_MEDIUM = css`
  ${H2}
  font-weight: 500;
`;

export const H2_SEMIBOLD = css`
  ${H2}
  font-weight: 600;
`;

export const H2_BOLD = css`
  ${H2}
  font-weight: 700;
`;

//HeadLine H2

export const H3 = css`
  ${CommonTypographyStyle}
  font-size: 24px;
  line-height: 32px;
`;

export const H3_REGULAR = css`
  ${H3}
  font-weight: 400;
`;

export const H3_MEDIUM = css`
  ${H3}
  font-weight: 500;
`;

export const H3_SEMIBOLD = css`
  ${H3}
  font-weight: 600;
`;

export const H3_BOLD = css`
  ${H3}
  font-weight: 700;
`;

//Text Extra Small

export const TEXT_XS = css`
  ${CommonTypographyStyle}
  font-size: 10px;
  line-height: 14px;
`;

export const TEXT_XS_REGULAR = css`
  ${TEXT_XS}
  font-weight: 400;
`;

export const TEXT_XS_MEDIUM = css`
  ${TEXT_XS}
  font-weight: 500;
`;

export const TEXT_XS_SEMIBOLD = css`
  ${TEXT_XS}
  font-weight: 600;
`;

//Text Small

export const TEXT_SM = css`
  ${CommonTypographyStyle}
  font-size: 12px;
  line-height: 18px;
`;

export const TEXT_SM_REGULAR = css`
  ${TEXT_SM}
  font-weight: 400;
`;

export const TEXT_SM_MEDIUM = css`
  ${TEXT_SM}
  font-weight: 500;
`;

export const TEXT_SM_BOLD = css`
  ${TEXT_SM}
  font-weight: 700;
`;

//Text Medium

export const TEXT_M = css`
  ${CommonTypographyStyle}
  font-size: 14px;
  line-height: 24px;
`;

export const TEXT_M_REGULAR = css`
  ${TEXT_M}
  font-weight: 400;
`;

export const TEXT_M_MEDIUM = css`
  ${TEXT_M}
  font-weight: 500;
`;

export const TEXT_M_SEMIBOLD = css`
  ${TEXT_M}
  font-weight: 600;
`;

export const TEXT_M_BOLD = css`
  ${TEXT_M}
  font-weight: 700;
`;

//Text Large

export const TEXT_LG = css`
  ${CommonTypographyStyle}
  font-size: 16px;
  line-height: 24px;
`;

export const TEXT_LG_REGULAR = css`
  ${TEXT_LG}
  font-weight: 400;
`;

export const TEXT_LG_MEDIUM = css`
  ${TEXT_LG}
  font-weight: 500;
`;

export const TEXT_LG_SEMIBOLD = css`
  ${TEXT_LG}
  font-weight: 600;
`;

//Text Extra Large
export const TEXT_XL = css`
  ${CommonTypographyStyle}
  font-size: 18px;
  line-height: 28px;
`;

export const TEXT_XL_REGULAR = css`
  ${TEXT_XL}
  font-weight: 400;
`;

export const TEXT_XL_MEDIUM = css`
  ${TEXT_XL}
  font-weight: 500;
`;

export const TEXT_11_400 = css`
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`;
export const TEXT_11_500 = css`
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
`;
export const TEXT_11_700 = css`
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 1.1px;
`;

export const TEXT_12_400 = css`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const TEXT_14_400 = css`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;

export const TEXT_14_500 = css`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
`;

export const TEXT_14_600 = css`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
`;

export const TEXT_15_400 = css`
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 29px;
`;

export const TEXT_15_500 = css`
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const TEXT_15_700 = css`
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const TEXT_16_400 = css`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const TEXT_16_500 = css`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const TEXT_16_600 = css`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const TEXT_20_700 = css`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 160% */
  letter-spacing: -0.6px;
`;

export const TEXT_24_700 = css`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
`;

export const TEXT_32_700 = css`
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const TEXT_36_700 = css`
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
`;

export const TEXT_96_400 = css`
  font-size: 96px;
  font-style: normal;
  font-weight: 400;
  line-height: 90px;
  letter-spacing: -2.88px;
`;

export const TEXT_180_400 = css`
  font-size: 180px;
  font-style: normal;
  font-weight: 400;
  line-height: 139px;
  letter-spacing: -4.5px;
`;
